var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow90DegLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.044,
    height: 15,
    viewBox: "0 0 13.044 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0e0e0f;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.249 -2.249)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.277,2.441a.652.652,0,0,1,0,.923L3.824,6.815l3.452,3.451a.653.653,0,1,1-.923.923L2.441,7.277a.652.652,0,0,1,0-.923L6.353,2.441a.652.652,0,0,1,.923,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.75,5.9A.652.652,0,0,1,3.4,5.25H11.88A3.261,3.261,0,0,1,15.14,8.511v7.173a.652.652,0,1,1-1.3,0V8.511A1.956,1.956,0,0,0,11.88,6.554H3.4A.652.652,0,0,1,2.75,5.9Z",
    transform: "translate(0.152 0.913)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow90DegLeft);
export default __webpack_public_path__ + "static/media/arrow-90deg-left.1fab0d6d88f067bd840f0a014cdc7796.svg";
export { ForwardRef as ReactComponent };